window.ProjetFlexCreate = {
    load: function () {

        // Input listeners

        const document_number = $('#document_number');

        document_number.on('keyup', function () {
            ProjetFlexCreate.update_document_number_mask_behavior($(this).val());
            if ($(this).val().length >= 12) {
                ProjetFlexCreate.watch.document_number($(this).val());
            }
        });

        document_number.on('blur', function () {
            ProjetFlexCreate.watch.document_number($(this).val());
        });

        $('#title').on('blur', function () {
            ProjetFlexCreate.watch.title($(this).val());
        });

        $('#goal').on('blur', function () {
            ProjetFlexCreate.watch.goal($(this).val());
        });

        $('#duration').on('blur', function () {
            ProjetFlexCreate.watch.duration($(this).val());
        });

        $('#tag_line').on('blur', function () {
            ProjetFlexCreate.watch.tag_line($(this).val());
        });

        $('#about_project').on('blur', function () {
            ProjetFlexCreate.watch.about_project($(this).val());
        });

        $('#optional_payw').on('blur', function () {
            ProjetFlexCreate.watch.payw($(this).val());
            $('span.terms-payw').html($(this).val() + '%');
        });

        $('#office_number').on('blur', function () {
            ProjetFlexCreate.watch.office_number($(this).val());
        });

        $('#account_number').on('blur', function () {
            ProjetFlexCreate.watch.account_number($(this).val());
        });

        $('#account_digit').on('blur', function () {
            ProjetFlexCreate.watch.account_digit($(this).val());
        });

        $('#legal_name').on('blur', function () {
            ProjetFlexCreate.watch.legal_name($(this).val());
        });

        $('#contact_phone').on('blur', function () {
            ProjetFlexCreate.watch.contact_phone($(this).val());
        });

        // Terms

        $(".go-to-step").click(function () {
            $(".terms-step").removeClass('show').addClass('hide');
            $(".terms-step[data-step='" + $(this).data('step') + "']").addClass('show');
        });

        // Payw

        $("input[name=payw]").change(function () {
            let paywAlternativeOption = $(".payw-alternative-option");
            let currentValue = $(this).val();
            if (currentValue === 'optional') {
                paywAlternativeOption.show();
            } else {
                paywAlternativeOption.hide();
                updatePayw();
            }
            ProjetFlexCreate.watch.payw();
        });

        function updatePayw() {
            let paywOptionValue = document.querySelector('input[name=payw]:checked').value;
            $('#optional_payw').val(paywOptionValue);
            let paywValue = document.querySelector('input#optional_payw').value;
            $('span.terms-payw').html(paywValue + '%');
        }

        // Submission

        $('#validate').click(function () {
            if (ProjetFlexCreate.validate() === true) {
                $("#terms-modal").modal();
            } else {
                alert('Existem campos não preenchidos')
            }
        });

        $('#save-and-continue').click(function () {
            $('#publish').val('false');
            ProjetFlexCreate.submit(false);
        });

        $('#save-and-publish').click(function () {
            ProjetFlexCreate.submit();
        });

        // Masks

        $('#title').mask('Z', {
            translation: {
                'Z': {
                    pattern: /^[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/g,
                    recursive: true
                }
            }
        });
        $('#goal').mask('000.000.000.000.000', {reverse: true});
        $('#duration').mask('00');
        $('#office_number').mask('99999');
        $('#office_digit').mask('9');
        $('#account_number').mask('#');
        $('#account_digit').mask('AA');
        $('#optional_payw').mask('99.99');
        $('#contact_phone').mask('(00) 00000-0000');
        updatePayw();
    },
    watch: {
        required: ($refField, $refSpan) => {
            if (!FormGenericValidator.required($refField.val())) {
                BSForm.error($refField, $refSpan, "Este campo deve ser preenchido");
                return false;
            } else return true;
        },
        title: function () {
            if (!ProjetFlexCreate.watch.required($('#title'), $('#title_validation'))) return false;
            BSForm.success($('#title'), $('#title_validation'));
            return true;
        },
        goal: function () {
            if (!ProjetFlexCreate.watch.required($('#goal'), $('#goal_validation'))) return false;

            const val = $('#goal').val().replace('.', '');

            if (val < 500) {
                BSForm.error($('#goal'), $('#goal_validation'), 'Valor abaixo do mínimo');
                return false;
            }

            BSForm.success($('#goal'), $('#goal_validation'));
            return true;
        },
        duration: function () {
            if (!ProjetFlexCreate.watch.required($('#duration'), $('#duration_validation'))) return false;

            const val = $('#duration').val();

            if (val < 1) {
                BSForm.error($('#duration'), $('#duration_validation'), 'Valor mínimo inválido');
                return false;
            }

            if (val > 60) {
                BSForm.error($('#duration'), $('#duration_validation'), 'Valor máximo excedido');
                return false;
            }

            BSForm.success($('#duration'), $('#duration_validation'));
            return true;
        },
        tag_line: function() {
            if (!ProjetFlexCreate.watch.required($('#tag_line'), $('#tag_line_validation'))) return false;

            BSForm.success($('#tag_line'), $('#tag_line_validation'));
            return true;
        },
        about_project: function () {
            if (!ProjetFlexCreate.watch.required($('#about_project'), $('#about_project_validation'))) return false;
            BSForm.success($('#about_project'), $('#about_project_validation'));
            return true;
        },
        payw: function() {
            if (!ProjetFlexCreate.watch.required($('#optional_payw'), $('#optional_payw_validation'))) return false;

            const val = $('#optional_payw').val();

            if (val > 95.5) {
                BSForm.error($('#optional_payw'), $('#optional_payw_validation'), 'Valor máximo excedido');
                return false;
            }

            BSForm.success($('#optional_payw'), $('#optional_payw_validation'));
            return true;
        },
        office_number: function () {
            if (!ProjetFlexCreate.watch.required($('#office_number'), $('#office_number_validation'))) return false;
            BSForm.success($('#office_number'), $('#office_number_validation'));
            return true;
        },
        account_number: function () {
            if (!ProjetFlexCreate.watch.required($('#account_number'), $('#account_number_validation'))) return false;
            BSForm.success($('#account_number'), $('#account_number_validation'));
            return true;
        },
        account_digit: function () {
            if (!ProjetFlexCreate.watch.required($('#account_digit'), $('#account_digit_validation'))) return false;
            BSForm.success($('#account_digit'), $('#account_digit_validation'));
            return true;
        },
        legal_name: function () {
            if (!ProjetFlexCreate.watch.required($('#legal_name'), $('#legal_name_validation'))) return false;
            BSForm.success($('#legal_name'), $('#legal_name_validation'));
            return true;
        },
        document_number: function () {
            const val = $("#document_number").val();
            const document_number_type = ProjetFlexCreate.get_document_number_type(val);
            let valid = true;

            switch (document_number_type) {
                case 'pf':
                    valid = FormGenericValidator.cpf(val);
                    break;

                case 'pj':
                    valid = FormGenericValidator.cnpj(val);
                    break;
            }

            if (valid !== true) {
                BSForm.error($('#document_number'), $('#document_number_validation'), 'Documento inválido');
                return false;
            } else {
                BSForm.success($('#document_number'), $('#document_number_validation'));
                return true;
            }
        },
        contact_phone: function () {
            if (!ProjetFlexCreate.watch.required($('#contact_phone'), $('#contact_phone_validation'))) return false;
            BSForm.success($('#contact_phone'), $('#contact_phone_validation'));
            return true;
        },
    },
    validate: function () {
        ProjetFlexCreate.watch.title();
        ProjetFlexCreate.watch.goal();
        ProjetFlexCreate.watch.duration();
        ProjetFlexCreate.watch.tag_line();
        ProjetFlexCreate.watch.about_project();
        ProjetFlexCreate.watch.payw();
        ProjetFlexCreate.watch.office_number();
        ProjetFlexCreate.watch.account_number();
        ProjetFlexCreate.watch.account_digit();
        ProjetFlexCreate.watch.legal_name();
        ProjetFlexCreate.watch.document_number();
        ProjetFlexCreate.watch.contact_phone();

        return ProjetFlexCreate.watch.title() &&
            ProjetFlexCreate.watch.goal() &&
            ProjetFlexCreate.watch.duration() &&
            ProjetFlexCreate.watch.tag_line() &&
            ProjetFlexCreate.watch.about_project() &&
            ProjetFlexCreate.watch.payw() &&
            ProjetFlexCreate.watch.office_number() &&
            ProjetFlexCreate.watch.account_number() &&
            ProjetFlexCreate.watch.account_digit() &&
            ProjetFlexCreate.watch.legal_name() &&
            ProjetFlexCreate.watch.document_number() &&
            ProjetFlexCreate.watch.contact_phone();
    },
    submit: function (checkValidation = true) {
        function submit() {

            $('#goal').val($('#goal').val().replace('.', ''));

            if ($('#publish').val() === 'false') {
                $('#save-and-continue').button('loading');
                $('#save-and-publish').button('loading');
                $('#create-project-form').submit();
            } else if ($('input[name=terms]:checked').val() === 'on') {
                $('#save-and-continue').button('loading');
                $('#save-and-publish').button('loading');
                $('#create-project-form').submit();
            } else {
                alert('Por favor, confirme o aceite aos termos de uso e de compromisso, política de privacidade, valores, taxas e prazos');
            }
        }

        if (checkValidation === true) {
            if (ProjetFlexCreate.validate() === true) {
                submit();
            }
        } else {
            submit();
        }
    },
    get_document_number_type: function (val) {
        return val.length <= 14 ? 'pf' : 'pj';
    },
    update_document_number_mask_behavior: function (val) {
        const document_number_mask_behavior = function (val) {
                return val.length <= 14 ? '000.000.000-009' : '00.000.000/0000-00';
            },
            document_number_options = {
                onKeyPress: function (val, e, field, options) {
                    field.mask(document_number_mask_behavior.apply({}, arguments), options);
                }
            };
        $('#document_number').mask(document_number_mask_behavior, document_number_options);
    }
};

if($('#create-project').length) ProjetFlexCreate.load();